<div class="change-password-modal">
    <div class="modal-header">
        <div class="header-label">{{'login.ChangePassword' | translate}}</div>
        <div class="cancel-right-icon">
            <i aria-hidden="true" class="close-icon icon-requisition-denied"
                (click)="this.dialogRef.close('Cancel');"></i>
        </div>
    </div>

    <div class="modal-body">
        <form class="change-password-form" [formGroup]="homeGroup">
            <div class="change-password">
                <div class="new-password">
                    <mat-label class="agy-mat-label"><span class="manditory-icon">*</span> {{'login.NewPassword' |
                        translate}}</mat-label>
                    <mat-form-field appearance="outline">
                        <input [autocomplete]="'off'" [type]="hideNewPW ? 'password' : 'text'" matInput id="password"
                            formControlName="newPassword">
                        <i matSuffix (click)="hideNewPassword($event)"
                            [ngClass]="hideNewPW ? 'opacity1 icon-hide-password' : 'opacity0 icon-reveal-password'"></i>
                    </mat-form-field>
                    @if (newPasswordErrorMessage !== '') {
                    <span class="new-password-error-message">{{newPasswordErrorMessage}}</span>
                    }
                    @if (homeGroup.get('newPassword')?.hasError('required') && homeGroup.get('newPassword')?.touched) {
                    <span class="new-password-error-message">{{ 'Login.NewPasswordRequired' | translate }}</span>
                    }
                </div>
                <div class="confirm-password">
                    <mat-label class="agy-mat-label"><span class="manditory-icon">*</span>{{'login.ConfirmPassword' |
                        translate}}</mat-label>
                    <mat-form-field appearance="outline">
                        <input [autocomplete]="'off'" [type]="hidePassword ? 'password' : 'text'" matInput
                            id="confirmPassword" formControlName="confirmPassword">
                        <i matSuffix (click)="hideConfirmPassword($event)"
                            [ngClass]="hidePassword ? 'opacity1 icon-hide-password' : 'opacity0 icon-reveal-password'"></i>
                    </mat-form-field>
                    @if (errorMessage !== '') {
                    <span class="no-match-password-error-message">{{errorMessage}}</span>
                    }
                    @if (homeGroup.get('confirmPassword')?.hasError('required') &&
                    homeGroup.get('confirmPassword')?.touched) {
                    <span class="no-match-password-error-message">{{ 'Login.ConfirmPasswordRequired' | translate
                        }}</span>
                    }
                </div>
            </div>

            <div class="password-complexity-content">
                @if (data?.PasswordComplexityConditions) {
                <div class="password-complexity-validation-check">
                    <span class="product-caption">{{'PasswordComplexity.PasswordShallHaveText' | translate}}</span>
                    @for (condition of data.PasswordComplexityConditions; track condition) {
                    <div class="password-condition">
                        <i
                            [ngClass]="{'icon-requisition-approved': (condition.ValidIcon === true), 'icon-requisition-denied': (condition.ValidIcon === false), 'icon-tick': (condition.ValidIcon === null)}"></i><span
                            class="password-condition-display-name">{{condition.PasswordConditionDisplayName}}</span>
                    </div>
                    }
                </div>
                }
            </div>

            <div class="change-password-button">
                <button mat-raised-button color="primary" class="full-width"
                    (click)="changePassword($event)">{{'login.ChangePassword' | translate}}</button>
            </div>
        </form>
    </div>
</div>